import React, { useEffect, useRef, useState } from "react";
import InsideHeader from "../../../components/InsideHeader";
import svg76 from "../../../assets/svg/svg76.svg";
import svg77 from "../../../assets/svg/svg77.svg";
import svg27 from "../../../assets/svg/svg27.svg";
import svg80 from "../../../assets/svg/svg80.svg";
import svg88 from "../../../assets/svg/svg88.svg";
import deleteSvg from "../../../assets/svg/delete-red.svg";
import { Checkbox, Divider, Dropdown, Form, Table, Tag } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../../../features/dropdown/dropdownSlice";
import Search from "../../../components/Search";
import moment from "moment";
import {
  setActiveObj,
  setViewMode,
} from "../../../features/folder/folderSlice";
import toast from "react-hot-toast";
import { save } from "../../../features/save/saveSlice";
import CardLoading from "../../../components/CardLoading";
import { cashConverter, formatText } from "../../../utils";
import ConfirmModal from "../../../components/ConfirmModal";

function ActivityTable() {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "api/v1/activities/fetch";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.dropdown.loading,
    data: state.dropdown.data[url] || [],
    count: state.dropdown.count[url] || 0,
  }));
  const { saving } = useSelector((state) => state.save);

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };
  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: `api/v1/activities/delete/${prodd?.jaaId}`, 
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await setOpenDelete(false);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        jaaTitle: e.target.value == "" ? null : e.target.value,
      })
    );
  };

  const handleEdit = async () => {
    await dispatch(setActiveObj({ key: "activity", data: prodd }));
    await navigate("/recruitment/activity-stepper");
  };
  const handleDisable = () => {};
  const handleAdd = async () => {
    await dispatch(setActiveObj({ key: "activity", data: {} }));
    await navigate("/recruitment/activity-stepper");
  };
  const handleView = async () => {
    await dispatch(setActiveObj({ key: "activity", data: prodd }));
    await navigate("/recruitment/activity-view");
  };
  const handleViewName = async (item) => {
    await dispatch(setActiveObj({ key: "activity", data: item })); 
 await navigate("/recruitment/activity-view");
  };

  const settingItems = [
    {
      key: "0",
      label: (
        <Link
          className="flex gap-x-[.75rem] items-center py-[.5rem]"
          onClick={handleView}
        >
          <img src={svg88} alt="svg88" className="w-4 h-4" />{" "}
          <span className="whitespace-nowrap">View</span>
        </Link>
      ),
    },
    {
      key: "divider-0",
      type: "divider",
    },
     ...(prodd?.jaaStatus === "DRAFT"
    ? [
        {
          key: "1",
          label: (
            <Link
              className="flex gap-x-[.75rem] items-center py-[.5rem]"
              onClick={handleEdit}
            >
              <img src={svg80} alt="svg80" className="w-4 h-4" />{" "}
              <span className="whitespace-nowrap">Edit</span>
            </Link>
          ),
        },
      ]
    : []),
 
    {
      key: "divider-1",
      type: "divider",
    },
    {
      key: "2",
      label: (
        <Link
          className="flex items-center gap-x-2 py-[.5rem]"
          onClick={handleOpenDelete}
        >
          <img src={deleteSvg} alt="deleteSvg" className="w-4 h-4" />
          <span className="whitespace-nowrap">Delete</span>
        </Link>
      ),
    },
    {
      key: "divider-2",
      type: "divider",
    },
  ];

  const plainOptions = ["All_activities", "Upcomming", "Past"];
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [popoverVisible, setPopoverVisible] = useState(false);

  const handleRemoveFilter = (removedStatus) => (e) => {
    console.log("clicked");
    e.preventDefault();
    setSelectedFilters((prev) =>
      prev?.filter((status) => status !== removedStatus)
    );
  };
  const onChangeFilter = (checkedValues) => {
    setSelectedFilters(checkedValues);
  };

  const handleApply = async () => {
    await setPopoverVisible(false);
    console.log("Apply filters:", selectedFilters);
  };

  const handleReset = async () => {
    await setSelectedFilters([]);
    await setPopoverVisible(false);
  };
  const filterOverlay = (
    <div className="w-[15.6875rem] p-[1.5rem] bg-white rounded-[.5rem] shadow-[0_0_13.9px_0_rgba(0,0,0,0.08)]">
      <p className="font-semibold">Select Filter</p>
      <Checkbox.Group
        options={plainOptions}
        value={selectedFilters}
        onChange={onChangeFilter}
        className="filter-checkbox"
      />

      <Divider />

      <div className="flex justify-center gap-[1.5rem] mt-3 font-dmSans text-[.875rem] font-[400]">
        <span className="text-[#FDB505]  cursor-pointer" onClick={handleReset}>
          Reset
        </span>
        <span className="text-[#C62130]  cursor-pointer" onClick={handleApply}>
          Apply
        </span>
      </div>
    </div>
  );

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: "5%",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Activity Title",
      render: (item) => {
        return (
          <div className="cursor-pointer" onClick={() => handleViewName(item)}>
            {item?.jaaTitle}
          </div>
        );
      },
      sorter: (a, b) => a.jaaTitle.localeCompare(b.jaaTitle),
    },

    {
      title: "Type",
      dataIndex: "jaaType",
      sorter: (a, b) => a.jaaType.localeCompare(b.jaaType),
    },

    {
      title: "Date",
      dataIndex: "jaaStartDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
      sorter: (a, b) =>
        moment(a.jaaStartDate).valueOf() - moment(b.jaaStartDate).valueOf(),
    },
    {
      title: "Start Time",
      dataIndex: "jaaStartTime",
    },
    {
      title: "End Time",
      dataIndex: "jaaEndTime",
    },
    {
      title: "Status",
      dataIndex: "jaaStatus",
      render: (item) => {
        const colors = {
          ACTIVE: "#28a745",
          DRAFT: "#6c757d",
        };

        return (
          <div
            className="text-[#FFF] inline-block rounded-[8px] px-[8px] py-[4px] w-auto !text-[12px]"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          > 
            {formatText(item)}
          </div>
        );
      },
    },
    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
  }, []);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <>
      <div className="w-full h-full overflow-y-scroll">
        <InsideHeader
          title="Activities"
          subtitle="Manage your activities such as meetings and interviews"
          back={false}
        />

        <div className="white_card mt-[2.5rem] flex-1 min-h-[70vh] ">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-[1rem]">
              <div className="lg:w-[35.125rem] w-auto ">
                <Search
                  searchInput={searchInput}
                  handleSearch={handleSearch}
                  text={"Search ..."}
                />
              </div>

              <>
                <div className="">
                  <Dropdown
                    overlay={filterOverlay}
                    trigger={["click"]}
                    placement="bottom"
                    open={popoverVisible}
                    onOpenChange={(visible) => setPopoverVisible(visible)}
                  >
                    <div className="flex items-center cursor-pointer text-[#706F6F] text-[.875rem] font-[400] font-dmSans">
                      <span>Filter</span>
                      <img src={svg77} alt="filter icon" className="ml-1" />
                    </div>
                  </Dropdown>
                </div>
              </>
            </div>

            <div className="w-[200px]">
              <button onClick={() => handleAdd()} className="cstm-btn">
                <img src={svg76} alt="svg76" />{" "}
                <span className="ml-1">New Activity</span>
              </button>
            </div>
          </div>

          <div className="mt-[1.25rem]">
            {selectedFilters &&
              selectedFilters?.map((status) => {
                const statusColors = {
                  All_activities: "#706F6F",
                  Upcomming: "#569D6E",
                  Past: "#DAA520",
                };
                return (
                  <Tag
                    closeIcon
                    onClose={handleRemoveFilter(status)}
                    className="inline-block w-fit max-w-max px-[.5rem] py-[.25rem] bg-[#E8EEED]
                            rounded-[2.1875rem] text-[.75rem] font-[400]"
                    style={{ color: statusColors[status] || "#000" }}
                  >
                    {formatText(status)}
                  </Tag>
                );
              })}
          </div>
          <Table
            rowSelection={false}
            className="mt-[1.31rem] w-full"
            scroll={{
              x: "auto",
            }}
            rowKey={(record) => record?.jaaId}
            columns={columns}
            dataSource={data}
            loading={loading}
            pagination={{
              position: ["bottomRight"],
              current: pageIndex + 1,
              total: count,
              pageSize: pageSize,
              onChange: (page, size) => {
                setPageIndex(page - 1);
                setPageSize(size);
                fetchTableData(page - 1, size);
              },
              showSizeChanger: false,
              hideOnSinglePage: true,
            }}
          />
        </div>
      </div>

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={saving}
        content={`Are you sure you want to delete ${prodd?.jaaTitle}`}
        type="alert"
        btnTitle="Confirm"
      />
    </>
  );
}

export default ActivityTable;
